import React, { FC } from 'react';

// tslint:disable-next-line:max-line-length
import { UserActionRecordPagination } from '@go-shared/types/userActionRecord';
import { Pagination } from '@go-client/components/UIkit/Pagination/Pagination';
import { BubbleNavigation } from '@go-client/components/BubbleUI';
import { UserActionRecordUIFilters } from '@go-client/pages/UserActions/UsersActions';

interface UserRecordsHeaderProps {
  onFiltersChange: (filters: UserActionRecordUIFilters) => void;
  pagination?: UserActionRecordPagination;
  activeFilters: UserActionRecordUIFilters;
}

export const UserActionsHeader: FC<UserRecordsHeaderProps> = ({
  onFiltersChange,
  pagination,
  activeFilters,
}) => {
  const changePage = (filters: UserActionRecordUIFilters, resetPage = true) => {
    const newFiltersConfig = { ...filters, page: resetPage ? 1 : filters.page };
    onFiltersChange(newFiltersConfig);
  };

  return (
    <div className="UserRecordsHeader align-with-logo flex items-end px-5 sticky top-0 left-0 z-10 bg-blue-lightest">
      <div className="mb-3 pl-3 flex items-center justify-between w-full">
        <div className="">
          <BubbleNavigation
            items={[
              {
                name: 'User Actions',
                to: '',
                active: true,
                variant: 'titanium',
              },
            ]}
          ></BubbleNavigation>
        </div>

        {pagination && pagination.count && (
          <>
            <div>
              <h4>
                Showing{' '}
                <b>
                  {activeFilters.page === 1
                    ? 1
                    : (activeFilters.page - 1) * pagination.recordsPerPage}
                </b>{' '}
                to{' '}
                <b>
                  {pagination.count < activeFilters.page * pagination.recordsPerPage
                    ? pagination.count
                    : activeFilters.page * pagination.recordsPerPage}
                </b>{' '}
                of <b>{pagination.count}</b> result{pagination.count === 1 ? '' : 's'}
              </h4>
            </div>

            <div className="mr-4">
              {pagination.pages !== 0 && (
                <Pagination
                  actualPage={activeFilters.page}
                  pages={pagination.pages}
                  onPageChange={(_, to) => {
                    changePage({ ...activeFilters, page: to }, false);
                  }}
                />
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};
